import { getListingData } from '@comp/page/search/get-listing-data'
import { houseSearchType } from '@lib/config'
import { isArray, map } from 'lodash-es'

export function getPremiumListings(listings, solds) {
  const l = map(
    isArray(listings) ? listings : [],
    (item) => getListingData(item, houseSearchType.residential)
  )
  
  const s = map(isArray(solds) ? solds : [], (item) => {
    const tmp = { ...item }
    if(item.sold_info) tmp.sold_date = item.sold_info?.sold_date

    const address = []
    if(item.street) address.push(item.street)
    if(item.suburb) address.push(item.suburb)
    if(item.district) address.push(item.district)

    tmp.display_address = address.join(', ')
    tmp.sold_price_label = item.sold_price_label || item.price_bold
    
    return getListingData(tmp, houseSearchType.sold)
  })
  
  return [...l, ...s]
}
